module.exports = __webpack_public_path__ + "static/img/wechat-qrcode.bfee588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat-qrcode.jpg
// module id = shs4
// module chunks = 68